/**IMGE LOADING */
import db from "../../assets/database_design.png";
// import web_dev from '../../assets/web_dev.jpeg';
import web_dev from "../../assets/web_development2.png";
import rpython from "../../assets/r_python.png";
import data_analytics from "../../assets/data_analytics.jpeg";
import consulting from "../../assets/ideas.png";
import rshiny from "../../assets/rshiny.jpeg";
import router from "../../assets/router.jpeg";
import itimage from "../../assets/itimage.jpeg";
import networking from "../../assets/it-networking.jpeg";
import itprinter from "../../assets/it-printer.jpeg";
import itcyber from "../../assets/it-cyber.jpeg";
import webdesign from "../../assets/it-webdesign.jpeg";
import itai from "../../assets/it-aiauto.jpeg";

export const projects = [
  
    {
      image: itimage,
      title: "IT Support",
      text: "Keep your tech running right—computers, internet, and devices supported so your business stays on track.",
      tag: "tech",
      link: "",
      date: "2017-01-01",
    },
    {
      image: router,
      title: "Wi-Fi Setup and Optimization",
      text: "Fast, reliable Wi-Fi with expert router setup and improved speed, performance, and coverage throughout your space.",
      tag: "network",
      link: "",
      date: "2018-01-01",
    },
    {
      image: networking,
      title: "Network Installation and Configuration",
      text: "Connect all your devices with a professionally installed and configured network for smooth day-to-day operations.",
      tag: "network",
      link: "",
      date: "2019-04-01",
    },
    {
      image: itprinter,
      title: "Printer and Smart Device Setup",
      text: "Seamless installation of printers and smart devices—fully connected to your network and ready to go.",
      tag: "devices",
      link: "",
      date: "2019-01-01",
    },
    {
      image: itcyber,
      title: "Cybersecurity & Data Backup",
      text: "Protect your systems from threats and keep your data safe with secure backups and proactive security.",
      tag: "security",
      link: "",
      date: "2019-07-01",
    },
    {
      image: webdesign,
      title: "Website Design, Hosting & Management",
      text: "Get a clean, professional website designed, hosted, and managed—so you can focus on your business.",
      tag: "web",
      link: "",
      date: "2019-04-01",
    },
    {
      image: itai,
      title: "AI Integration & Automation",
      text: "Streamline your operations with custom AI tools that automate tasks and boost your efficiency.",
      tag: "ai",
      link: "",
      date: "2020-01-01",
    },  
  ]

  //############### FAUSTTECH PROJECT #####################
  // {
  //   image: db,
  //   title: "IT Support",
  //   text: "Deploy and sustain secure database solutions to help you manage your data.",
  //   tag: "data",
  //   link: "",
  //   date: "2017-01-01",
  // },
  // {
  //   image: data_analytics,
  //   title: "Data Analysis",
  //   text: "Analyze data big and small to extract actionable insights.",
  //   tag: "data",
  //   link: "https://play.google.com/store/apps/details?id=com.vcoolstudio.doublePark&hl=en_US",
  //   date: "2018-01-01",
  // },
  // {
  //   image: web_dev,
  //   title: "Web and Application Development",
  //   text: "Build custom web applications to meet your needs.",
  //   tag: "react",
  //   link: "",
  //   date: "2019-04-01",
  // },
  // {
  //   image: rpython,
  //   title: "Data Science Ecosystems",
  //   text: "Deploy and sustain R shiny server and workbench for an entire data science suite.",
  //   tag: "react",
  //   link: "",
  //   date: "2019-01-01",
  // },
  // {
  //   image: rshiny,
  //   title: "Shiny Server",
  //   text: "Need a mobile application built for your business? We provide services for mobile application design to deployment.",
  //   tag: "react",
  //   link: "",
  //   date: "2019-07-01",
  // },
  // {
  //   image: consulting,
  //   title: "Technology Consulting Services",
  //   text: "Provide technology reccomendations for your business model.",
  //   tag: "react",
  //   link: "",
  //   date: "2019-04-01",
  // },

  // {
  //     'image': react_native,
  //     'title': 'Mobile Applications',
  //     'text': 'Need a mobile application built for your business? We provide services for mobile application design to deployment.',
  //     'tag': 'react',
  //     'link': '',
  //     'date': '2019-07-01'
  // },

